
export const getters = {
  // AWS Cognito shortcuts
  authenticated: (state, getters) => getters['cognito/authenticated'],
  roles: (state, getters) => getters['cognito/roles'],
  role: (state, getters) => (...roles) => getters['cognito/inRole'](roles),
}
